(function ($, undefined) {

    "use strict";

    /**
     * jQuery-ui plugin to turn a multiselect into a tree select field.
     *
     *     @example
     *     $('select#project_distributionLevels').treeSelect();
     *
     * @class jQuery.catalogFilter
     */
    $.widget("ofcs.treeSelect", {

        widgetEventPrefix: 'select',

        widgetBaseClass: 'ofcs-tree-select',

        options: {
            emptyText: 'Gibts nicht'
        },

        /**
         * Initializes a new tree select instance
         */
        _create: function () {
            var self     = this,
                options  = this.options,
                keyCode  = $.ui.keyCode,
                element  = this.element,
                wrapper  = this._wrapper = $('<div tabindex="0" class="tree-select-wrapper"></div>'),
                placeholder = this._emptyPlaceholder = $('<li><a href=""></a></li>');


            element.addClass(this.widgetBaseClass)
                   .hide();

            placeholder.children('a').text(options.emptyText);

            $(document).on('click', function () {
                setTimeout(function () {
                    var isTreeSelect = $(document.activeElement).hasClass('cursor-aware');

                    if(wrapper.hasClass('ui-state-focus') && !isTreeSelect) {
                        self._hideMenu();
                    }
                }, 0);
            });

            this._on(wrapper, {
                'keydown .tag, .cursor-aware': function(event) {
                    var elem = $(event.target),
                        keyCode = $.ui.keyCode,
                        newElem;
                    if (event.keyCode === keyCode.LEFT && (this._isCursorAtStart(event.target) || elem.is('.tag'))) {
                        newElem = elem.prev();
                        if (newElem.length) {
                            newElem.trigger('focus');
                            this._moveCursorToEnd(newElem[0]);
                        }
                    } else if (event.keyCode === keyCode.RIGHT && (this._isCursorAtEnd(event.target) || elem.is('.tag'))) {
                        elem.next().trigger('focus');
                    }
                },
                'keydown .tag': function(event) {
                    var tag, nextAware;
                    if (event.keyCode === keyCode.BACKSPACE || event.keyCode === keyCode.DELETE) {
                        tag = $(event.target);
                        nextAware = tag.next('.cursor-aware');
                        this._removeTag(tag);
                        nextAware.trigger('focus');
                        event.preventDefault();
                    }
                },
                'keydown .cursor-aware': "_onCursorAwareKeyDown",
                'keyup .cursor-aware': "_onCursorAwareKeyUp",
                'mousedown': function(event) {
                    var elem;
                    if (event.target === wrapper[0]) {
                        elem = wrapper.children('.cursor-aware:last');
                        elem.trigger('focus');
                        this._moveCursorToEnd(elem[0]);
                        this._showMenu();
                        event.preventDefault();
                    }
                },
                'focus': function(event) {
                    wrapper.children('.cursor-aware:last').trigger('focus');
                    event.preventDefault();
                },
                'mousedown .tag': function(event) {
                    $(event.target).trigger('focus');
                },
                'click .tag .remove': function(event) {
                    var tag = $(event.target).parent(),
                        nextAware = tag.next('.cursor-aware');
                    this._removeTag(tag);
                    nextAware.trigger('focus');
                    event.preventDefault();
                },
                'focus .cursor-aware, .tag': function(event) {
                    var elem = $(event.target);

                    // This fixes the order of blur and focus events
                    if (document.activeElement !== event.target) {
                        $(document.activeElement).blur();
                    }

                    if (elem.is('.cursor-aware')) {
                        this._currentCursorAware = $(event.target);
                    }
                    wrapper.addClass('ui-state-focus')
                           .attr('tabindex', '-1');
                },
                'focusout .cursor-aware, .tag': function() {
                    var self = this,
                        focusedElement;

                    setTimeout(function () {
                        focusedElement = document.activeElement.nodeName;

                        if(focusedElement === 'UL') {
                            return false;
                        }

                        wrapper.removeClass('ui-state-focus')
                            .attr('tabindex', '0');
                        self._hideMenu();
                    }, 0);
                }
            });

            element.children(':selected').each(function() {
                self._addTag(this);
            });

            wrapper.insertAfter(element);

            this._initMenu();
            this._ensureCursorAwares();

            if (element.setValidationTarget) {
                element.setValidationTarget(wrapper);
            } else {
                element.data("validation-target", wrapper);
            }

        },

        /**
         * Initializes a new menu based on the options of the multi select
         *
         * @private
         */
        _initMenu: function() {
            var self = this,
                wrapper = this._wrapper,
                menu = $('<ul />'),
                items = self._items = [],
                elemsToIds = {};

            this.element.children('option').each(function() {
                var option = $(this),
                    elem = $('<li class="elem"></li>'),
                    id = option.attr('value'),
                    text = self._cleanupOptionText(option.text()),
                    link = $('<a href=""></a>');

                link.text(text)
                    .css('padding-left', option.data('level') * 15 + 20);

                link.prepend('<i class="icon icon-caret-right"></i>');

                elem.data({
                        'parent-id': option.data('parent'),
                        'id': id,
                        'text': text.toLowerCase(),
                        'children': []
                    })
                    .append(link);

                items.push(elem);
                elemsToIds[id] = elem;

                menu.append(elem);
            });

            $.each(items, function(id, item) {
                var parentId = item.data('parent-id');
                if (parentId) {
                    elemsToIds[parentId].data('children').push(item);
                }
            });

            menu.on('menuselect', $.proxy(this._onMenuSelect, this));

            menu.menu()
                .insertAfter(wrapper);

            this._menu = menu.data('uiMenu');
        },

        _onMenuSelect: function(event, ui) {
            var item = ui.item,
                id   = item.data('id'),
                elem = this.element,
                optionElem = elem.children('[value=' + id + ']'),
                selected = elem.val() || [],
                tag;

            this._hideMenu();

            selected.push(id);
            elem.val(selected);
            elem.trigger("change");

            tag = this._addTag(optionElem, this._currentCursorAware);
            this._ensureCursorAwares();
            tag.next('.cursor-aware').trigger('focus');

            event.preventDefault();
        },

        _addTag: function(option, replace) {
            var tag = $('<span class="tag badge" tabindex="-1"><span class="text"></span><i class="remove icon-remove"></i></span>'),
                wrapper = this._wrapper;

            option = $(option);

            tag.data('id', option.attr('value'))
               .children('.text')
               .text(this._cleanupOptionText(option.text()));

            if (replace && replace.length > 0) {
                replace.replaceWith(tag);
            } else {
                tag.appendTo(wrapper);
            }

            return tag;
        },

        _removeTag: function(tag) {
            var valuesWithoutTag,
                elem   = this.element,
                id     = tag.data('id'),
                values = elem.val();

            valuesWithoutTag = $.grep(values, function(value) {
                return value !== id;
            });

            elem.val(valuesWithoutTag);
            elem.trigger("change");

            tag.prev('.cursor-aware').remove();
            tag.remove();

            this._ensureCursorAwares();
        },

        _ensureCursorAwares: function() {
            var inputTemplate = '<div class="cursor-aware" tabindex="-1" contenteditable />',
                wrapper = this._wrapper;

            if(!wrapper.children(':first').is('.cursor-aware')) {
                wrapper.prepend(inputTemplate);
            }

            wrapper.children('.tag').each(function () {
                if (!$(this).next().is('.cursor-aware')) {
                    $(inputTemplate).insertAfter(this);
                }
            });
        },

        _showMenu: function() {
            var menu = this._menu,
                elem = menu.element;

            if (!elem.is(':visible')) {
                elem.show();
                elem.scrollTop(0);
            }

            this._positionMenu();
            this._filterMenu();
            this._ensureActiveMenuItem();
        },

        _hideMenu: function() {
            var menu = this._menu;
            menu.element.hide()
        },

        _positionMenu: function() {
            this._menu.element.position({
                my: "left top-2",
                at: "left bottom",
                of: this._wrapper
            });
        },

        /**
         * Sets the cursor position to the end of the given content editable.
         * This solution comes from [StackOverflow][1].
         *
         * [1]: http://stackoverflow.com/questions/1125292/how-to-move-cursor-to-end-of-contenteditable-entity#3866442
         *
         * @param {DOMElement} elem
         * @private
         */
        _moveCursorToEnd: function (elem) {
            var range,selection;
            if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
            {
                range = document.createRange();//Create a range (a range is a like the selection but invisible)
                range.selectNodeContents(elem);//Select the entire contents of the element with the range
                range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
                selection = window.getSelection();//get the selection object (allows you to change selection)
                selection.removeAllRanges();//remove any selections already made
                selection.addRange(range);//make the range you have just created the visible selection
            }
            else if(document.selection)//IE 8 and lower
            {
                range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
                range.moveToElementText(elem);//Select the entire contents of the element with the range
                range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
                range.select();//Select the range (make it the visible selection
            }
        },

        _getCursorPosition: function(elem) {
            var caretPos = -1,
                sel, range;

            if (window.getSelection) {
                sel = window.getSelection();
                if (sel.rangeCount) {
                    range = sel.getRangeAt(0);
                    if (range.commonAncestorContainer === elem
                            || range.commonAncestorContainer.parentNode === elem) {
                        caretPos = range.endOffset;
                    }
                }
            } else if (document.selection && document.selection.createRange) {
                range = document.selection.createRange();
                if (range.parentElement() == elem) {
                    var tempEl = document.createElement("span");
                    elem.insertBefore(tempEl, elem.firstChild);
                    var tempRange = range.duplicate();
                    tempRange.moveToElementText(tempEl);
                    tempRange.setEndPoint("EndToEnd", range);
                    caretPos = tempRange.text.length;
                }
            }

            return caretPos;
        },

        _isCursorAtStart: function(elem) {
            return this._getCursorPosition(elem) === 0;
        },

        _isCursorAtEnd: function(elem) {
            return this._getCursorPosition(elem) === $(elem).text().length;
        },

        _cleanupOptionText: function(text) {
            var matches = text?.trim().match(/^-*(.*)$/);
            return matches ? matches[1] : text;
        },

        _onCursorAwareKeyDown: function(event) {
            var keyCode = $.ui.keyCode,
                menu = this._menu,
                elem = $(event.target);

            switch(event.keyCode) {
                case keyCode.UP:
                    menu.previous(event);
                    event.preventDefault();
                    break;
                case keyCode.DOWN:
                    if (menu.element.is(':visible')) {
                        menu.next(event);
                    } else {
                        this._showMenu();
                    }
                    event.preventDefault();
                    break;
                case keyCode.TAB:
                    if (menu.element.is(':visible')) {
                        event.preventDefault();
                        if (menu.active && !menu.active.is('.ui-state-disabled')) {
                            menu.select(event);
                        }
                    }
                    break;
                case keyCode.ENTER:
                    if (menu.active && !menu.active.is('.ui-state-disabled')) {
                        menu.select(event);
                    }
                    event.preventDefault();
                    break;
                case keyCode.BACKSPACE:
                    if (elem.text() === "") {
                        elem.prev().trigger('focus');
                        event.preventDefault();
                    }
                    break;
                case keyCode.DELETE:
                    if (elem.text() === "") {
                        elem.next().trigger('focus');
                        event.preventDefault();
                    }
                    break;
                case keyCode.ESCAPE:
                    this._hideMenu();
                    break;
                case keyCode.LEFT:
                case keyCode.RIGHT:
                case keyCode.SHIFT:
                case keyCode.HOME:
                case keyCode.END:
                case 16: // shift
                    // Do nothing
                    break;
                default:
                    this._showMenu();
                    break;
            }
        },

        _onCursorAwareKeyUp: function(event) {
            var keyCode = $.ui.keyCode;
            if (event.keyCode !== keyCode.UP
                && event.keyCode !== keyCode.DOWN
                && event.keyCode !== keyCode.ENTER) {
                this._positionMenu();
                this._filterMenu();
                this._ensureActiveMenuItem();
            }
        },

        _filterMenu: function() {

            var menu = this._menu,
                menuEl = menu.element,
                items  = this._items,
                text = this._currentCursorAware.text(),
                selected = this.element.val();

            text = text.toLowerCase();

            menuEl.children()
                  .removeClass("ui-state-disabled")
                  .detach();

            function isMatch(elem) {
                return elem.data('text').indexOf(text) !== -1;
            }

            function isParentOfMatch(elem) {
                var i, children = elem.data('children');

                if (children) {
                    for (i = 0; i < children.length; i++) {
                        if (isMatch(children[i]) || isParentOfMatch(children[i])) {
                            return true;
                        }
                    }
                }
                return false;
            }

            $.each(items, function(idx, item) {
                if (isMatch(item)) {
                    item.appendTo(menuEl);
                    if ($.inArray(item.data("id"), selected) !== -1) {
                        item.addClass('ui-state-disabled')
                            .find('.icon')
                            .removeClass('icon-caret-right')
                            .addClass('icon-ok');
                    } else {
                        item.find('.icon')
                            .addClass('icon-caret-right')
                            .removeClass('icon-ok');
                    }
                } else if (isParentOfMatch(item)) {
                    item.appendTo(menuEl);
                    item.addClass('ui-state-disabled');
                }
            });

            if (menuEl.children().length === 0) {
                menuEl.append(this._emptyPlaceholder.addClass("ui-state-disabled"));
            }
        },

        _ensureActiveMenuItem: function() {
            var menu = this._menu,
                items = menu.element.children(),
                active = menu.active,
                currentText = this._currentCursorAware.text(),
                nextActive;

            if (currentText === "") {
                menu.blur();
            } else if (!active || active.is('.ui-state-disabled') || items.index(active) === -1) {
                nextActive = items.filter(':not(.ui-state-disabled):first');
                if (nextActive.length) {
                    menu.focus(null, nextActive);
                } else {
                    menu.blur();
                }
            }
        },

        _destroy: function() {
            this._wrapper.remove();
            this.element.show();
        }

    });

}(jQuery));
